// hooks/useUrlParams.js
import { useSearchParams } from 'react-router-dom';

const useUrlParams = () => {
    const [searchParams] = useSearchParams();
    return Object.fromEntries(searchParams.entries());
};

export default useUrlParams;